import { atom } from "jotai";

export const solicitudesPersonalAtom = atom([]);
export const solicitudPersonalIdSeleccionadoAtom = atom(undefined);
export const visibleModalCancelarSolicitudAtom = atom(false);

export const loadingSolicitudAtom = atom(false);

export const filtroEstadoSolicitudPersonalAtom = atom (undefined);
